/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {Component, OnInit, signal} from '@angular/core';
import {EsciComponent} from '../esci.component';
import {environment} from '../../../environments/environment';

@Component({
    selector: 'app-clear-caches',
    templateUrl: './clear-caches.component.html',
    styleUrls: ['./clear-caches.component.scss'],
    standalone: false
})
export class ClearCachesComponent extends EsciComponent implements OnInit {
    private readonly clearCachesLoadingSignal = signal(false);
    private readonly clearCachesMessageSignal = signal('');
    private readonly clearCachesErrorSignal = signal('');
    permissionUrl = '/esciUI/esciITAdminPermission';

    ngOnInit(): void {
        this.permission.set(false);
        this.esciService.checkPermission(this);
    }

    get loading(): boolean {
        return this.clearCachesLoadingSignal();
    }

    set loading(value: boolean) {
        this.clearCachesLoadingSignal.set(value);
    }

    get message(): string {
        return this.clearCachesMessageSignal();
    }

    set message(value: string) {
        this.clearCachesMessageSignal.set(value ?? '');
    }

    get error(): string {
        return this.clearCachesErrorSignal();
    }

    set error(value: string) {
        this.clearCachesErrorSignal.set(value ?? '');
    }

    clearCaches(): void {
        this.loading = true;
        this.message = '';
        this.error = '';

        const url = `${environment.apiUrl}/esciUI/clearCaches`;
        this.http.get(url, {responseType: 'text'}).subscribe({
            next: (response: string) => {
                this.loading = false;
                this.message = response || 'Caches cleared successfully';
            },
            error: (err: any) => {
                this.loading = false;
                this.error = 'Failed to clear caches. Please try again.';
                console.error('Error clearing caches:', err);
                if (this.messageService) {
                    this.messageService.processError('Failed to clear caches. Please try again.');
                }
            }
        });
    }
}
